import React, { useEffect, useState } from 'react';
import {
  Card, Form, Row, Col, Button,
  Badge,
} from 'react-bootstrap';

import _ from 'lodash';
import MaterialTable, { MTableToolbar } from 'material-table';
import api from '../../api';

import Required from '../Required';
import { styledTable, styledTableHeading } from '../../helpers';
import { localization, modifyDefaultOptions, tableIconsModified } from '../../helpers/table';
import { dateRenderer } from '../../services/formatSvc';
import useToast from '../../hooks/useToast';

export default function BuyProjResults({ buy, onChange, readOnly }) {
  const addToast = useToast();

  const [projResults, setProjResults] = useState([]);
  useEffect(async () => {
    const res = await api.get(`/projs/${buy.projId}/results/0/list?type=recent`);
    if (res.error) addToast.error('Не удалось получить список уникальных результатов');
    else setProjResults(res || []);
  }, []);

  const [editMode, setEditMode] = useState(false);
  // #region Modify items
  const handleResultAdd = (resultId) => {
    const newResult = projResults.find((r) => r.id === resultId);
    const letters = (buy.projResults || []).map((r) => r.letterCode);
    if (letters.length > 0 && !letters.includes(newResult.letterCode)) {
      addToast.error('Результаты должны принадлежать одному мероприятию');
    } else {
      setEditMode(false);
      const changedResults = buy.projResults ? [...buy.projResults] : [];
      changedResults.push(projResults.find((r) => r.id === resultId));
      onChange(changedResults, 'projResults');
    }
  };
  const handleResultDelete = (resultId) => {
    onChange([...buy.projResults.filter((r) => r.id !== resultId)], 'projResults');
  };
    // #endregion

  const columns = [
    { title: 'Наименование', field: 'title', width: '50%' },
    { title: 'Год', field: 'year', width: '10%' },
    { title: 'Ед.измерения', field: 'unit', width: '10%' },
    { title: 'Значение', field: 'value', width: '10%' },
    { title: 'Мероприятие Постановления', field: 'letterCode', width: '10%' },
  ];

  return (
    <Card className="mb-4">
      <Card.Header as={Card.Title} className="p-4">Уникальные результаты проекта</Card.Header>
      <Card.Body className="p-4">
        <Row className="mb-4">
          <Col md={3}>
            <Button variant="primary" hidden={editMode || readOnly} onClick={() => setEditMode(true)}>
              Добавить
              результат
            </Button>
          </Col>
          <Form.Group as={Col} md="12" hidden={!editMode || readOnly}>
            <Form.Label>Мероприятие Постановления</Form.Label>
            <Form.Control
              as="select"
              placeholder="Выберите результат из списка результатов проекта"
              value=""
              onChange={(e) => handleResultAdd(parseInt(e.target.value))}
            >
              <option key="blankChoice" hidden value />
              {projResults
                .filter((r) => (!buy.projResults || !buy.projResults.find((br) => br.id === r.id)) && (!buy.year || r.year >= buy.year))
                .map((r) => (
                  <option key={r.id} value={r.id}>
                    {r.letterCode}
                    )
                    {' '}
                    {r.year}
                    г. -
                    "
                    {r.title}
                    "
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
        </Row>
        <div>
          <MaterialTable
            options={modifyDefaultOptions({
              actionsColumnIndex: -1,
              filtering: false,
              paging: false,
              search: false,
              toolbar: false,
            })}
            editable={readOnly
              ? false
              : {
                onRowDelete: (oldData) =>
                  new Promise(async (resolve, reject) => {
                    await handleResultDelete(oldData.id);
                    resolve();
                  }),
              }}
            icons={tableIconsModified}
            localization={localization}
            columns={columns}
            data={buy.projResults}
          />
        </div>
      </Card.Body>
    </Card>
  );
}

const cardHeaderStyling = {
  display: 'flex', justifyContent: 'end', minHeight: 38,
};
